import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Füge Fade-Out-Event-Listener hinzu
    this.element.addEventListener('turbo:before-cache', this.fadeOut.bind(this))
  }

  disconnect() {
    // Entferne Event-Listener
    this.element.removeEventListener('turbo:before-cache', this.fadeOut.bind(this))
  }

  fadeOut() {
    // Füge Fade-Out-Animation hinzu
    this.element.classList.remove('animate__fadeIn')
    this.element.classList.add('animate__fadeOut', 'animate__faster')
    
    // Warte bis Animation fertig ist, dann entferne Element
    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.parentNode.removeChild(this.element)
      }
    }, 300) // 300ms für animate__faster
  }

  // Methode für Click-Event
  fadeOutOnClick(event) {
    // Verhindere Standard-Verhalten
    event.preventDefault()
    
    // Starte Fade-Out-Animation
    this.fadeOut()
    
    // Sende DELETE-Request nach Animation
    setTimeout(() => {
      const form = event.target.closest('form')
      if (form) {
        form.submit()
      }
    }, 300)
  }
}
